
import storeDateSelectorResolve from '../../directive/store-date-selector/store-date-selector.resolve';

export default function routes($stateProvider) {

	$stateProvider
		.state('surveyStatsPage', {
			url:     '/survey/:id/stats/:stores?startDate&endDate',
			resolve: {
				...storeDateSelectorResolve,
				survey: ['loggedIn', 'Survey', '$stateParams', function (loggedIn, Survey, $stateParams) {
					return Survey.get($stateParams.id);
				}],
				stats: ['loggedIn', 'Survey', '$stateParams', 'selectedStore', 'endDate', 'startDate', function (loggedIn, Survey, $stateParams, selectedStore, endDate, startDate) {
					return Survey.getStats({
						surveyId: $stateParams.id,
						stores: JSON.stringify(selectedStore.storeIds),
                        startDate,
                        endDate
					});
				}]
			},
			template: require('./surveyStats.html'),
			controller: 'SurveyStatsController',
			controllerAs: 'surveyStats'
		});

}

routes.$inject = ['$stateProvider'];



// WEBPACK FOOTER //
// ./src/page/surveyStats/surveyStats.routes.js